import { styled } from '@mui/material/styles'

export const TosContent = styled('div')(
	({ theme }) => `
	max-height: 50vh;
	overflow: auto;
	border: 1px solid #ccc;
	padding: ${theme.spacing(2)};
	margin-bottom: ${theme.spacing(3)};

	@media (max-width: ${theme.breakpoints.values.sm}px) {
		max-height: 60vh;
		padding: ${theme.spacing(1.5)};
	}
`,
)
export const ButtonsContainer = styled('div')(
	({ theme }) => `
	display: flex;
	justify-content: center;
	gap: ${theme.spacing(2.5)};
	flex-wrap: wrap;

	@media (max-width: ${theme.breakpoints.values.sm}px) {
		gap: ${theme.spacing(1.5)};
	}
`,
)
